<template>
  <div class="lg:ml-5  flex ">
    <div class="ml-auto w-3">
      <IconField>
        <InputIcon class="pi pi-search" />
        <InputText
          id="search"
          v-model="searchValue"
          type="search"
          class="pl-4 w-12"
          @change="doSearch()"
        />
      </IconField>
    </div>
    <div class="ml-auto">
      <Button
        label="Add"
        icon="pi pi-check"
        raised
        @click="addChat()"
      />
    </div>
  </div>

  <div class="grid max-h-full overflow-scroll">
    <!--Left Menu-->
    <div class=" col-3 flex-column">
      <DataView
        :value="chats"
        layout="list"
        :rows="4"
        :paginator="true"
        :always-show-paginator="true"
        :page-link-size="3"
      >
        <template #list="slotProps">
          <div class="flex flex-column">
            <div
              v-for="(item, index) in slotProps.items"
              :key="index"
            >
              <div
                class="border-solid surface-border cursor-pointer"
                @click="selectChat(item.conversation)"
              >
                <span class="flex flex-col sm:flex-row sm:items-center p-2 gap-4">
                  {{ item.project }}
                </span>
                <p class="p-2">
                  {{ item.summary }}
                </p>
              </div>
            </div>
          </div>
        </template>
      </DataView>
    </div>
    <!--Chat window-->
    <div class="col-9 max-h-full overflow-scroll">
      <!--No chat selected-->
      <div
        v-if="!selectedChat.length"
        class="w-full p-2"
      >
        <span class="text-center">Please Select a chat</span>
      </div>
      <div
        v-else
        style="height: 600px; overflow: hidden;"
      >
        <!-- Iterate over the selectedChat array to display messages -->
        <div
          v-for="(chat, index) in selectedChat"
          :key="index"
          class="p-2"
        >
          <div :class="[chat.person === 'me' ? 'ml-auto' : 'mr-auto']">
            <span> {{ chat.person }}</span>
          </div>

          <div
            :class="[
              'border-round-md p-2 mb-2 rounded-lg',
              chat.person === 'me' ? 'bg-blue-500 text-white ml-auto' : 'bg-gray-200 text-black mr-auto'
            ]"
            style="max-width: 70%;"
          >
            <span>{{ chat.message }}</span>
          </div>
        </div>
      </div>
      <!--chat message box-->
      <div
        v-if="selectedChat.length"
        style="height: 50px;"
      >
        <div class="flex justify-content-center">
          <InputText
            id="message"
            v-model="messageValue"
            type="message"
            class="w-10"
          />
          <Button
            label="Send"
            class="pl-2"
            icon="pi pi-check"
            raised
            @click="sendChat()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
//Primevue Imports


import { ref, onMounted } from 'vue';

import { createChats } from '@/data/faker'
const chats = ref([])
const selectedChat = ref([])
const searchValue = ref('');
const doSearch = () => {
    console.log('searching')
    if (searchValue.value.length > 3) {
        console.log(searchValue.value)
    }

}

// Populate contacts when the component is mounted
onMounted(() => {
    chats.value = createChats(100); // Generate 100 contacts
});

//Selects the chat to be shown in the main window
const selectChat = (value) => {
    selectedChat.value = value
    console.log('value', value)

}

//Show the Add contact Modal
const addChat = () => { }
</script>
